import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { Router } from '@angular/router';
@Component({
  selector: 'upsc-defence-popup',
  templateUrl: './defence-popup.component.html',
  styleUrls: ['./defence-popup.component.scss']
})
export class DefencePopupComponent implements OnInit {

  count: number = 1;
  header: string = 'What’s new with Parcel Pro.';
  buttonChange: string = 'Get 50 Complimentary Scores Now';

  constructor(private router: Router, public dialogRef: MatDialogRef<DefencePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) {

  }

  ngOnInit(): void {
    if (this.data.monthlyTierType > 1) {
      this.buttonChange = 'Start Now';
      const el = document.getElementById("buttonCls");
      if (el) {
        el.style.fontSize = "20px";
      }
    }
   
  }
  public nextButton() {
    if (this.count == 3) {
      this.count = 0;
    }
    this.count = this.count + 1;
  }

  public previousButton() {
    if (this.count == 1) {
      this.count = 4;
    }
    this.count = this.count - 1;
  }

  public actionBtn(event){
    let id = event.target.id;
    let slide = id.match(/\d+/);  
    this.count = parseInt(slide[0], 10);
  }

  public signUp() {
    this.dialogRef.close();
    this.router.navigate(['/delivery-defense-sign-up']);
  }
  
  public faq() {
    this.dialogRef.close();
    this.router.navigate(['/delivery-defense-faq']);
  }
}
